function ceremonyTimestamp(ceremony) {
  if (Number.isFinite(ceremony?.sortTs)) return ceremony.sortTs
  const timestamp = new Date(
    ceremony?.datetime || ceremony?.ceremony_datetime || ''
  ).getTime()
  return Number.isFinite(timestamp) ? timestamp : null
}

export function buildCeremonySeasons(ceremonies, options = {}) {
  const requestedGapDays = Number(options.gapDays)
  const gapDays = Number.isFinite(requestedGapDays) ? requestedGapDays : 14
  const locale = options.locale || 'en-GB'
  const sorted = [...(ceremonies || [])]
    .filter(ceremony => ceremony?.id)
    .map(ceremony => ({
      ...ceremony,
      seasonSortTs: ceremonyTimestamp(ceremony),
    }))
    .sort((a, b) => {
      const aTs = a.seasonSortTs ?? Number.MAX_SAFE_INTEGER
      const bTs = b.seasonSortTs ?? Number.MAX_SAFE_INTEGER
      return aTs - bTs || String(a.id).localeCompare(String(b.id))
    })

  const groups = []
  const maxGapMs = gapDays * 24 * 60 * 60 * 1000
  for (const ceremony of sorted) {
    const current = groups[groups.length - 1]
    const previous = current?.[current.length - 1]
    const startsNew = (
      !current
      || previous.seasonSortTs === null
      || ceremony.seasonSortTs === null
      || ceremony.seasonSortTs - previous.seasonSortTs > maxGapMs
    )
    if (startsNew) groups.push([ceremony])
    else current.push(ceremony)
  }

  const formatter = new Intl.DateTimeFormat(locale, {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  })
  return groups.map((group, index) => {
    const dated = group.filter(ceremony => ceremony.seasonSortTs !== null)
    const startTs = dated[0]?.seasonSortTs ?? null
    const endTs = dated[dated.length - 1]?.seasonSortTs ?? null
    let label = `Season ${index + 1}`
    if (startTs !== null && endTs !== null) {
      const start = formatter.format(new Date(startTs))
      const end = formatter.format(new Date(endTs))
      label = start === end ? start : `${start} - ${end}`
    }
    label = `${label} (${group.length} ceremon${group.length === 1 ? 'y' : 'ies'})`
    return {
      key: `season-${index + 1}-${group[0].id}`,
      label,
      ceremonyIds: group.map(ceremony => String(ceremony.id)),
      ceremonies: group,
      startTs,
      endTs,
    }
  }).sort((a, b) => (b.endTs || 0) - (a.endTs || 0))
}
